import { Reveal } from "./Reveal";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export function NextDriveCTA({ callOnly = false }: { callOnly?: boolean }) {
  return (
    <section className="py-16 md:py-20 lg:py-24 border-t border-border">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl text-foreground">
            Your next drive is waiting.
          </h2>
          <p className="mt-6 text-foreground/70 max-w-xl mx-auto">
            Book your vehicle in minutes. Instant confirmation online.
          </p>
          {callOnly ? (
            <div className="mt-10">
              <Button asChild className="h-14 w-full md:w-auto rounded-none shadow-none px-8 uppercase text-xs tracking-widest">
                <a href="tel:+17783798881"><Phone aria-hidden="true" />Call Now</a>
              </Button>
            </div>
          ) : (
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <a
              href="/book"
              className="text-xs uppercase tracking-[0.25em] px-8 py-4 bg-foreground text-background hover:bg-foreground/90 hover:tracking-[0.32em] hover:scale-[1.02] transition-all duration-300"
            >
              Book Now
            </a>
            <a
              href="tel:+17783798881"
              className="md:hidden text-xs uppercase tracking-[0.25em] px-8 py-4 border border-foreground text-foreground hover:bg-foreground hover:text-background transition-colors"
            >
              Call Now
            </a>
            <a
              href="/contact"
              className="hidden md:inline-flex items-center text-xs uppercase tracking-[0.25em] px-8 py-4 border border-foreground text-foreground hover:bg-foreground hover:text-background transition-colors"
            >
              Contact Us
            </a>
          </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
